export const view = {
  receipt: {
    create: 'Add Receipt',
    edit: 'Edit Receipt',
    delete: 'Delete Receipt',
    enRoute: 'En Route',
    receipts: 'Receipts',
  },
};
